import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'onboarding/register',
    pathMatch: 'full',
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./onboarding/onboarding.module').then((m) => m.OnboardingWebModule),
  },
  {
    path: 'teams/:appType',
    loadChildren: () => import('./teams/teams.module').then((m) => m.TeamsModule),
  },
  {
    path: 'payment',
    loadChildren: () => import('./checkout/checkout.module').then((m) => m.CheckoutWebModule),
  },
  {
    path: 'galleries',
    loadChildren: () => import('./galleries/galleries.module').then((m) => m.GalleriesModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
